// @flow
import styled from 'styled-components';

export const Table = styled.table`
  width: 100%;
  table-layout: fixed;
  
  border-collapse: collapse;
  border-spacing: 0;
`;

export const THead = styled.thead`
  position: relative;
`;

export const Th = styled.th`
  padding: ${({ theme: { V2 } }) => V2.metrics.margin.table.td}px 0;
`;

export const Td = styled.td`
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  
  padding: ${({ theme: { V2 } }) => V2.metrics.margin.table.td}px;
`;


export const TBody = styled.tbody`
  position: relative;
`;

export const Tr = styled.tr`
`;




// WEBPACK FOOTER //
// ./src/common/components/ui/Table.js